import React from "react";

const Contact: React.FC = () => {
  return (
    <section className="contact_page" style={{ padding: "50px"}}>
      <div className="container-fluid">
        <h2 style={{ color: "#e2520f", textAlign: "center", fontWeight: "bold", marginBottom: "80px" }}>
          Contact Us
        </h2>
        <div className="row">
          

          {/* Contact Us Section */}
          <div className="col-md-4 mb-4">
            <p style={{ marginBottom: "10px", fontWeight: "bold", color: "#0f174f", fontSize: "16px" }}>Sales</p>
            <p style={{ marginBottom: "20px", color: "#666", fontSize: "16px" }}>sales@ftthsa.co.za</p>
            <p style={{ marginBottom: "10px", fontWeight: "bold", color: "#0f174f", fontSize: "16px" }}>Support</p>
            <p style={{ marginBottom: "20px", color: "#666", fontSize: "16px" }}>support@gplat.co.za</p>
            <p style={{ marginBottom: "10px", fontWeight: "bold", color: "#0f174f", fontSize: "16px" }}>Call Us</p>
            <p style={{ marginBottom: "0", color: "#666", fontSize: "16px" }}>0861 777 889</p>
          </div>

          {/* Vacancies, Privacy Policy, Terms Section */}
          <div className="col-md-4 mb-4">
            <p style={{ color: "#0f174f", fontWeight: "bold", marginBottom: "20px", fontSize: "16px" }}>Vacancies</p>
            <p style={{ color: "#666", fontSize: "16px", marginBottom: "20px" }}>
              <a href="https://gplat.simplify.hr/#aboutCompany" style={{ textDecoration: "none", color: "#e2520f", fontWeight: "bold" }}>
                Click here to view jobs
              </a>
            </p>
            <p style={{ color: "#0f174f", fontWeight: "bold", marginBottom: "20px", fontSize: "16px" }}>Privacy Policy</p>
            <p style={{ color: "#666", fontSize: "16px", marginBottom: "20px" }}>
              <a href="/Privacy" style={{ textDecoration: "none", color: "#e2520f", fontWeight: "bold" }}>
                Read our Privacy Policy
              </a>
            </p>
            <p style={{ color: "#0f174f", fontWeight: "bold", marginBottom: "20px", fontSize: "16px" }}>Terms and Conditions</p>
            <p style={{ color: "#666", fontSize: "16px", marginBottom: "20px" }}>
              <a href="/Terms" style={{ textDecoration: "none", color: "#e2520f", fontWeight: "bold" }}>
                View Terms and Conditions
              </a>
            </p>
          </div>

          {/* Quick Response Paragraph and Follow Section */}
          <div className="col-md-4">
            <p style={{ color: "#666", fontSize: "16px", marginBottom: "20px" }}>
              We strive to provide quick responses to all inquiries. Whether you need assistance with sales, support, or general questions, our team is here to help. Feel free to reach out to us via email or call center, and we’ll get back to you as soon as possible.
            </p>
            <p style={{ color: "#e2520f", fontWeight: "bold", marginBottom: "15px", fontSize: "16px" }}>Follow</p>
            <p style={{ color: "#666", fontSize: "16px", marginBottom: "20px" }}>
              Stay connected with us on social media for updates and news.
            </p>
            <div>
              <a
                href="https://www.facebook.com/profile.php?id=100077963720140"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginRight: "10px",
                  color: "#0f174f",
                  fontSize: "20px",
                }}
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/ftthsa/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginRight: "10px",
                  color: "#0f174f",
                  fontSize: "20px",
                }}
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginRight: "10px",
                  color: "#0f174f",
                  fontSize: "20px",
                }}
              >
                <i className="bi bi-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#0f174f",
                  fontSize: "20px",
                }}
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <br/>
      <br/>
    </section>
  );
};

export default Contact;